class FetchBeneficiaries {
	constructor(
		public readonly accountId: number,
		// Already composed by the beneficiary filter view — this Query does not know the filter shape.
		// Emitted parameters: `page`, `rows`, `search`, `status`, `assignedUserId`, `facilityIds`
		// (repeated), no sort.
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}
}

export default FetchBeneficiaries;
